<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide7',
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 4500,
          end: 5000,
          fromStyle: { transform: 'translateY(-1000px)' },
          toStyle: { transform: 'translateY(150px)' },
          easing: 'linear'
        },
        {
          start: 6800,
          end: 7400,
          fromStyle: { transform: 'translateY(150px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(1500px) rotateZ(12deg)' },
          easing: 'linear'
        }
      ]
    };
  },
  mounted() {
    const text = '';
    const evidence = null;
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateY(150px)') {
          this.$readMore.value = text;
          this.$evidence.value = evidence;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slide7'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/07_Photo.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 450px;
    height: 500px;
    left: -230px;
    top: calc(50% - 400px);
    transition: 0.6s;
    z-index: 2;
    @media(max-width: 600px) {
      width: 200px;
      left: -110px;
    }
}
</style>
